import axios, { AxiosInstance } from 'axios'
import { CONFIG } from 'core/config'
import { getToken } from 'core/services/Storage'

const { chatUrl } = CONFIG

 const chatHttpClient: AxiosInstance = axios.create({
  baseURL: `${chatUrl}`,
})

chatHttpClient.interceptors.request.use(
  config => {
    config.headers.Authorization = getToken()
    return config
  },
  error => console.log(error)
)

export { chatHttpClient }
